package ui.widget

import androidx.compose.animation.*
import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.*
import androidx.compose.foundation.text.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.draw.*
import androidx.compose.ui.focus.*
import androidx.compose.ui.graphics.*
import androidx.compose.ui.text.input.*
import androidx.compose.ui.unit.*
import compose.assets.*
import compose.assets.svg.*
import org.jetbrains.compose.resources.*
import provider.*
import ssoft.frontend.generated.resources.*
import tools.*

@Composable
fun HomeSearchUI(
    filed: MutableState<TextFieldValue>,
    label: StringResource = Res.string.global_search,
    modifier: Modifier = Modifier.fillMaxWidth(),
    focus: FocusRequester = FocusRequester()
) {

    val display = LocalDisplayProvider.current

    SearchUI(
        filed = filed,
        modifier =
        if (display.isMobile) modifier
        else Modifier.width(384.dp),
        label = label,
        searchIcon = {
            LocalHomeDrawerProvider.current.MenuIcon {
                Icon(
                    imageVector = Svg.Search,
                    contentDescription = null,
                    modifier = Modifier
                        .size(48.dp)
                        .padding(12.dp),
                    tint = Color.White
                )
            }
        },
        focus = focus
    )

}

@Composable
fun SearchUI(
    filed: MutableState<TextFieldValue>,
    modifier: Modifier = Modifier.width(384.dp),
    label: StringResource = Res.string.global_search,
    searchIcon: (@Composable () -> Unit) = {
        Icon(
            imageVector = Svg.Search,
            contentDescription = null,
            modifier = Modifier
                .size(48.dp)
                .padding(12.dp),
            tint = Color.White
        )
    },
    focus: FocusRequester = FocusRequester(),
    onChange:(TextFieldValue) -> Unit = {}
) {
    val focusRequest = remember { focus }
    val shape = remember {
        RoundedCornerShape(50)
    }
    OutlinedCard(
        onClick = { focusRequest.requestFocus() },
        colors = CardDefaults.outlinedCardColors(containerColor = MaterialTheme.colorScheme.background),
        modifier = modifier.height(48.dp),
        shape = shape
    ) {
        Row(Modifier.fillMaxSize()) {
            searchIcon()
            Space(8.dp)
            Box(Modifier.weight(1F).fillMaxHeight()) {
                if (filed.value.text.trim().isEmpty()) {
                    Text(
                        text = label.rememberString(),
                        color = Color.LightGray,
                        modifier = Modifier.fillMaxWidth()
                            .align(Alignment.Center)
                    )
                }
                BasicTextField(
                    value = filed.value,
                    textStyle = MaterialTheme.typography.titleMedium.copy(color = Color.White),
                    modifier = Modifier.fillMaxWidth()
                        .focusRequester(focusRequest)
                        .align(Alignment.Center),
                    onValueChange = {
                        filed.value = it
                        onChange(it)
                    },
                    cursorBrush = SolidColor(Color.White),
                    singleLine = true,
                    maxLines = 1,
                    minLines = 1
                )

            }

            AnimatedVisibility(
                visible = filed.value.text.trim().isNotEmpty(),
                enter = fadeIn(),
                exit = fadeOut()
            ) {
                Icon(
                    imageVector = Svg.DeleteEmpty,
                    contentDescription = null,
                    modifier = Modifier.size(48.dp)
                        .clip(shape)
                        .clickable {
                            filed.value = TextFieldValue()
                            focusRequest.requestFocus()
                        }
                        .padding(12.dp))
            }
        }
    }

}
